import { JSX, useContext } from 'react';

import {
    Box,
    DialogTitle,
    DialogContent,
    DialogActions,
    Dialog,
    IconButton,
    Drawer
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/Help';
import { WorkflowContext } from "../../../../context/WorkflowContextProvider";

export const NodeTestOutputModal: () => JSX.Element = (): JSX.Element => {
    const context = useContext(WorkflowContext);

    function handleClose() {
        context.toggleShowTestOutputPanel(false)
    }
    return (
        <Drawer
            open={ context.showTestOutputPanel }
            anchor="bottom"
            onClose={handleClose}
        >

            <Box className="drawer__test-output">
                <Box className="close-control" display="flex" justifyContent="space-between">
                    <span>{ "Node Output" }</span>
                    <IconButton onClick={ handleClose }>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <span className="test-output__title" >{ "Data Models are converted to JSON" }</span>
                <Box className="output">
                    { context?.nodeTestOutputs?.map( (item: any, index: number) => {
                        return (
                            <Box
                                className="test-output__item"
                                key={ "node_test_output_" + index }>
                                <span>{ item.title }</span>
                                <pre>
                                    { item.data }
                                </pre>
                            </Box>
                        );
                    } )  }
                </Box>
            </Box>
        </Drawer>
    );
}